import axios from "axios";
import { API_BASE_URL } from "../../../config/apiConfig";
import { getStoredAccessToken } from "../../../utils/authSession";

const API = `${API_BASE_URL}/salary/v2/enterprise`;

function authHeaders() {
  const token = getStoredAccessToken();
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      "Content-Type": "application/json",
    },
  };
}

function unwrap(err) {
  throw err?.response?.data || err;
}

export async function entGetCatalog() {
  try {
    const res = await axios.get(`${API}/catalog`, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entGetDependencies() {
  try {
    const res = await axios.get(`${API}/dependencies`, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entSimulateFormula(payload) {
  try {
    const res = await axios.post(`${API}/formulas/simulate`, payload, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entBulkSeed(payload) {
  try {
    const res = await axios.post(`${API}/components/bulk-seed`, payload, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entListAudit(params = {}) {
  try {
    const res = await axios.get(`${API}/audit-logs`, { ...authHeaders(), params });
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entListScheduled(params = {}) {
  try {
    const res = await axios.get(`${API}/scheduled-earnings`, { ...authHeaders(), params });
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entCreateScheduled(payload) {
  try {
    const res = await axios.post(`${API}/scheduled-earnings`, payload, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entListBenefits(params = {}) {
  try {
    const res = await axios.get(`${API}/benefits`, { ...authHeaders(), params });
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entCreateBenefit(payload) {
  try {
    const res = await axios.post(`${API}/benefits`, payload, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entListDeductions(params = {}) {
  try {
    const res = await axios.get(`${API}/deductions`, { ...authHeaders(), params });
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entCreateDeduction(payload) {
  try {
    const res = await axios.post(`${API}/deductions`, payload, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entComputeArrear(payload) {
  try {
    const res = await axios.post(`${API}/arrears/compute`, payload, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entCreateArrear(payload) {
  try {
    const res = await axios.post(`${API}/arrears`, payload, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entListArrears(params = {}) {
  try {
    const res = await axios.get(`${API}/arrears`, { ...authHeaders(), params });
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entCreateCorrection(payload) {
  try {
    const res = await axios.post(`${API}/corrections`, payload, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entListCorrections() {
  try {
    const res = await axios.get(`${API}/corrections`, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}

export async function entRunSimulator(payload) {
  try {
    const res = await axios.post(`${API}/simulator`, payload, authHeaders());
    return res.data;
  } catch (e) {
    unwrap(e);
  }
}
